import React from "react";

function IconWizard() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="15"
      fill="none"
      viewBox="0 0 12 15"
    >
      <path
        fill="#272727"
        d="M4.65 11h.684V7.667h1.333V11h.685c.088-.801.496-1.463 1.16-2.185.075-.081.554-.578.611-.648a4 4 0 10-6.247-.002c.058.072.538.569.612.65.664.722 1.073 1.384 1.161 2.185zm.017 1.333V13h2.667v-.667H4.667zM1.837 9a5.333 5.333 0 118.326.001c-.413.515-1.496 1.332-1.496 2.332V13a1.333 1.333 0 01-1.333 1.333H4.667A1.334 1.334 0 013.334 13v-1.667c0-1-1.084-1.817-1.498-2.333z"
      ></path>
    </svg>
  );
}

export default IconWizard;
